"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.delete.confirm': 'Eliminar Tutorial',
    'tutorial.delete.confirmText': '¿Está seguro de que desea eliminar este tutorial? Esta acción no se puede deshacer.',
    'tutorial.delete.success': 'Tutorial eliminado correctamente',
};
